/**
  * Creates label/value pairs for dropdown options
  * @param {string} value - string value used for label and value
  * @return {object}
  */
const createOption = (value) => ({ label: value, value });

export default createOption;
